module.exports = __webpack_public_path__ + "img/wordpress.492e56f2.png";